import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { StoreProvider } from './lib/store';

function updateVisualViewportMetrics() {
  const viewport = window.visualViewport;
  const height = viewport?.height ?? window.innerHeight;
  const offsetTop = viewport?.offsetTop ?? 0;
  const keyboardOpen = window.innerHeight - height > 120;

  document.documentElement.style.setProperty('--app-viewport-height', `${Math.round(height)}px`);
  document.documentElement.style.setProperty('--app-viewport-offset-top', `${Math.round(offsetTop)}px`);
  document.documentElement.classList.toggle('keyboard-open', keyboardOpen);
}

function keepFocusedFieldVisible(event: FocusEvent) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement)) return;
  window.setTimeout(() => {
    const scroller = target.closest<HTMLElement>('.sheet-content');
    if (!scroller) return;
    const fieldRect = target.getBoundingClientRect();
    const scrollerRect = scroller.getBoundingClientRect();
    const footerAllowance = 92;
    if (fieldRect.bottom > scrollerRect.bottom - footerAllowance || fieldRect.top < scrollerRect.top + 8) {
      target.scrollIntoView({ block: 'center', behavior: document.documentElement.classList.contains('reduce-motion') ? 'auto' : 'smooth' });
    }
  }, 180);
}

updateVisualViewportMetrics();
window.addEventListener('resize', updateVisualViewportMetrics);
window.addEventListener('orientationchange', updateVisualViewportMetrics);
window.visualViewport?.addEventListener('resize', updateVisualViewportMetrics);
window.visualViewport?.addEventListener('scroll', updateVisualViewportMetrics);
document.addEventListener('focusin', keepFocusedFieldVisible);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StoreProvider><App/></StoreProvider>
  </React.StrictMode>,
);
